import { render, staticRenderFns } from "./EditReceiverForm.vue?vue&type=template&id=210edffa&"
import script from "./EditReceiverForm.vue?vue&type=script&lang=ts&"
export * from "./EditReceiverForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports